const  router = [
	{
		path: "/gift/layout",
		component: () => import('../../../pages/gift/Layout.vue'),
		meta: {title: '礼品'},
		name: 'gift_layout',
		children:[
			{
				path: "/gift",
				component: () => import('../../../pages/gift/ManageGoods.vue'),
				meta: {title: '兑换礼品', type:'c', permission: 'gift_index'},
				name: 'giftIndex'
			},
			{
				path: "/gift/editGoods",
				component: () => import('../../../pages/gift/EditGoods.vue'),
				meta: {title: '编辑礼品', type:'c', permission: 'gift_edit'},
				name: 'gift_edit'
			},
			{
				path: "/gift/order",
				component: () => import('../../../pages/gift/Order.vue'),
				meta: {title: '兑换记录', type:'c', permission: 'gift_order'},
				name: 'gift_order'
			},
			{
				path: "/gift/order/detail",
				component: () => import('../../../pages/gift/OrderDetail.vue'),
				meta: {title: '兑换订单详情', type:'c', permission: 'gift_order_detail'},
				name: 'gift_order_detail'
			},
		],
	}
];

export default router